import { Controller, useFormContext } from 'react-hook-form';
import { Grid, MenuItem } from '@mui/material';
import { Input } from '@shared';

interface Props {
  readOnly?: boolean;
}

export const StepMainCardholder = ({ readOnly }: Props) => {
  const { control } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={2}>
        <Controller
          name='mainTitle'
          control={control}
          rules={{ required: 'Title is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Title' margin='normal' required error={!!error} helperText={error?.message} inputProps={{ readOnly }} />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name='mainFirstName'
          control={control}
          rules={{ required: 'First Name is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='First Name' margin='normal' required error={!!error} helperText={error?.message} inputProps={{ readOnly }} />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <Controller
          name='mainMiddleName'
          control={control}
          render={({ field }) => <Input {...field} label='Middle Name' margin='normal' inputProps={{ readOnly }} />}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name='mainLastName'
          control={control}
          rules={{ required: 'Last Name is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Surname' margin='normal' required error={!!error} helperText={error?.message} inputProps={{ readOnly }} />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name='lastFourNumberOfCard'
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              label='Card number of main cardholder'
              margin='normal'
              helperText='(Last four digits only)'
              inputProps={{ readOnly, maxLength: 4 }}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name='relationshipToMain'
          control={control}
          rules={{ required: 'Relationship to main cardholder is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Relationship to main cardholder' margin='normal' select required error={!!error} helperText={error?.message}>
              <MenuItem value='Spouse/Partner'>Spouse/Partner</MenuItem>
              <MenuItem value='Child'>Child</MenuItem>
              <MenuItem value='Parent'>Parent</MenuItem>
            </Input>
          )}
        />
      </Grid>
    </Grid>
  );
};
